import styled from '@emotion/styled';
import { Typography } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';
import { SpriteImgIcon } from '@kc-console/shared-ui';

import { useRefinedRecentServiceState } from '../../../../hooks';
import { LnbDivider } from '../LnbDivider';
import RecentListItem from './RecentListItem';
import RecentMenuSection from './RecentMenuSection';

interface Props {
  /** LNB 메뉴 > 접힘 여부 */
  collapsed: boolean;
}

/**
 * 최근 사용 서비스 섹션 컴포넌트
 */
export default function RecentListSection({ collapsed }: Props) {
  const { t } = useTranslation();
  const { recentServices } = useRefinedRecentServiceState();
  const hasRecentServices = recentServices?.length > 0;

  return (
    <>
      {collapsed ? (
        hasRecentServices ? (
          <>
            <LnbDivider />
            <RecentMenuSection />
          </>
        ) : null
      ) : (
        <RecentServiceListContainer>
          <LnbDivider />
          <RecentListSubtitle id="recent-service-list-subheader">
            <Typography variant="label/medium/sm" color="text/weaker/default">
              {t('layout:lnb.recent.title')}
            </Typography>
          </RecentListSubtitle>
          {hasRecentServices ? (
            <nav aria-label="recent-service-list">
              {recentServices.map(({ path, name, keyword }) => (
                <RecentListItem
                  key={path}
                  label={name}
                  path={path}
                  startIcon={
                    <SpriteImgIcon fontSize={16} category={'BeyondServiceRegular'} id={keyword} />
                  }
                />
              ))}
            </nav>
          ) : (
            <RecentDescription variant="label/regular/sm">
              {t('layout:lnb.recent.empty')}
            </RecentDescription>
          )}
        </RecentServiceListContainer>
      )}
    </>
  );
}

const RecentDescription = styled(Typography)`
  padding: 0 16px;
  line-height: 20px;
  word-break: keep-all;
  color: ${({ theme }) => theme.color['text/weakest/default']};
`;

const RecentListSubtitle = styled.li`
  display: flex;
  align-items: center;
  padding: 12px 16px 6px;
  line-height: initial;
  background-color: initial;
`;
const RecentServiceListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 0 12px;
  margin-top: auto;
`;
